module.exports = __webpack_public_path__ + "static/media/plans.4b93f0d3.svg";